import { IconButton } from '@trg/tlw-ui-component';
import { useSearchStore } from '../../../search';

export function Search() {
  const setIsSearchOpen = useSearchStore.use.setIsSearchOpen();

  return (
    <IconButton
      className="tlw-p-0 tlw-text-2xl lg:tlw-text-xl"
      icon="SearchBg"
      square
      onClick={() => setIsSearchOpen(true)}
    />
  );
}
